













  import { Component, Prop } from 'vue-property-decorator'
  import { mixins } from 'nuxt-property-decorator'
  import { Products } from '@one/types'
  import {
    Cart,
    Wishlist,
  } from '@one/types/dist/orderpath/app'
  import { namespace } from 'vuex-class'
  import CurrentProductMixin from '~/mixins/CurrentProduct'
  import AddToCartMixin from '~/mixins/AddToCartMixin'
  import { ProductItem } from '~/plugins/gtm/gtm'

  const products = namespace('products')
  const wishlist = namespace('wishlist')

  type Relation = 'SIMILAR' | 'OTHER' | 'ACCESSORY'

  @Component({
    components: {
      OneRelatedProducts: () => import('~/components/organisms/catalog/OneRelatedProducts.vue'),
    },
  })
  export default class OneRelatedProductsGridWrapper extends mixins<
    CurrentProductMixin,
    AddToCartMixin
    >(CurrentProductMixin, AddToCartMixin) {
    @products.Getter getRelatedProducts: any
    @wishlist.Getter getCurrentWishlistId: any
    @wishlist.Action addProductToWishlist: any
    @wishlist.Getter getWishlistProduct: any
    @wishlist.Getter getCurrentWishlist: any

    @Prop({
      required: true,
      type: String,
    })
    readonly relationType!: Relation

    @Prop({
      required: false,
      type: String,
    })
    readonly title?: string

    @Prop({
      type: Boolean,
      default: false,
    })
    readonly isList!: boolean

    get products(): Array<Products.ProductIdAndQuantityDto> | null {
      if (!this.$product) {
        return null
      }
      const products = this.getRelatedProducts(this.$product.id, this.relationType)
      return (products && products.length) ? products : null
    }

    onAddToCart(e: Cart.Requests.AddProductToCart) {
      this.$wait.start('add-to-cart')
      this.addToCart(e.productId, e.amountOfProducts, 'product-page').finally(() =>
        this.$wait.end('add-to-cart'),
      )
    }

    onAddToWishlist(e: Wishlist.Requests.AddNumberOfProductsInWishlistOption) {
      this.addProductToWishlist({
        wishlistId: this.getCurrentWishlistId,
        newProduct: {
          productId: e.productId,
          amountOfProducts: e.amountOfProducts,
        },
      })
        .then(() => {
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('product_page.alert_added_to_wishlist') as string,
          })
          const addedProduct = this.getWishlistProduct(this.getCurrentWishlistId)(e.productId)
          this.$gtm.addToWishlist(
            {
              item_id: addedProduct.id,
              item_name: addedProduct.name,
              item_list_name: this.getCurrentWishlist.name,
              item_brand: addedProduct.brand?.name || '',
              category: this.$routes.getCategoryPath(addedProduct.canonicalCategory) || '',
              price: addedProduct.prices?.catalogPriceNet || 0,
              discount: addedProduct.prices?.catalogPriceDiscount || 0,
              quantity: e.amountOfProducts || 0,
            },
            addedProduct.prices.catalogPriceNet * (e.amountOfProducts || 0),
          )
        })
        .catch((err: any) => {
          this.$logger.warn(err)
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('errors.add_to_wishlist_error') as string,
          })
        })
    }

    onProductClick(product: Products.Product) {
      this.$router.push(this.$routes.getProductPath(product), () => {
        const price = this.getProductPrice(product.id)
        this.$gtm.selectItem(
          {
            item_name: product.name,
            item_id: product.id,
            item_brand: (product.brand && product.brand.name) || (product.manufacturer && product.manufacturer.name),
            category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
            price: price ? price.price : 0,
            discount: price ? price.catalogPrice - price.price : 0,
          } as ProductItem,
          this.relationType,
        )
      })
    }
  }
